import { render, staticRenderFns } from "./GroupHeaderTemplate.vue?vue&type=template&id=64f61720"
import script from "./GroupHeaderTemplate.vue?vue&type=script&lang=js"
export * from "./GroupHeaderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports